export default __webpack_public_path__ + "static/media/121.335f966f.jpg";